import axios from 'axios'
import { withApiBase, withBase, API_BASE } from '../../../config/api'
import { getCsrfToken } from '../../../utils/csrf'

export { API_BASE }


axios.defaults.withCredentials = true

export function authHeaders(method = 'GET') {
  if (['GET', 'HEAD', 'OPTIONS'].includes(method.toUpperCase())) return {}
  const csrfToken = getCsrfToken()
  return csrfToken ? { 'X-CSRF-Token': csrfToken } : {}
}

export const FUND_ACCOUNTS = ['CASHBACK_FUND', 'REFERRAL_FUND', 'MARGIN_FUND', 'VAT_FUND', 'BANK_OUT']
export const ACCOUNT_OPTIONS = ['', 'USER_WALLET', ...FUND_ACCOUNTS, 'BANK_OUT']
export const SOURCE_KNOWN = ['CASHBACK', 'CASHBACK_MONTHLY', 'REFERRAL_BONUS', 'PAYOUT']

export const toCents   = (v) => Math.round(Number(v || 0) * 100)
export const fromCents = (c) => c / 100
export const formatEUR = (n) =>
  Number(n || 0).toLocaleString('sk-SK', { style: 'currency', currency: 'EUR' })

export const isFund = (acc) => FUND_ACCOUNTS.includes(acc || '')

export function sortRows(arr, s) {
  const dir = s.dir === 'asc' ? 1 : -1
  const val = (r) => {
    switch (s.field) {
      case 'txn_id': return String(r.txn_id || '')
      case 'side': return String(r.side || '')
      case 'account': return String(r.account || '')
      case 'userId': return String(r.displayUserId ?? r.userId ?? '')
      case 'amount': return Number(r.amount || 0)
      case 'currency': return String(r.currency || '')
      case 'source': return String(r.source || '')
      case 'description': return String(r.description || '')
      case 'createdAt': return new Date(r.createdAt || 0).getTime()
      case 'transaction_ref': return String(r.transaction_ref || '')
      case 'email': return String(r.email || '')
      case 'meno': return String(r.meno || '')
      case 'priezvisko': return String(r.priezvisko || '')
      case 'iban': return String(r.iban || '')
      case 'paid_at': return new Date(r.paid_at || 0).getTime()
      case 'status': return String(r.status || '')
      default: return ''
    }
  }
  const a = [...arr]
  a.sort((x, y) => {
    const vx = val(x), vy = val(y)
    if (vx < vy) return -1 * dir
    if (vx > vy) return 1 * dir
    return 0
  })
  return a
}

export async function apiGet(url, params) {
  const qs = params ? `?${params.toString()}` : ''
  const res = await axios.get(withApiBase(url) + qs)
  return res.data
}

export async function loadBalances() {
  try {
    const data = await apiGet('/ledger/balances')
    return data.map(x => ({
      bucket: x.bucket,
      account: x.account,
      userId: x.userId,
      currency: x.currency || 'EUR',
      balance: Number(x.balance || 0),
    }))
  } catch {
    return []
  }
}

export async function loadAllocSummary() {
  try {
    const res = await axios.get(withBase('/admin/payment-allocations/summary'))
    return res.data?.balances || null
  } catch {
    return null
  }
}

export async function loadPayouts() {
  try {
    const res = await axios.get(withBase('/admin/payouts'))
    return Array.isArray(res.data) ? res.data : []
  } catch {
    return []
  }
}

export async function loadConsistency() {
  try {
    const res = await axios.get(withBase('/admin/ledger/consistency'))
    return Array.isArray(res.data) ? res.data : []
  } catch {
    return []
  }
}
